export enum DocumentTypeEnum {
  DOCUMENTS = "documents",
  CONTRACTS = "contracts",
}
